import Vue from 'vue'
import moment from 'moment-timezone'

export default {
  getTasks ({ commit }) {
    return Vue.api.get('engine/tasks')
      .then((res) => commit('init', { tasks: res.data }))
  },
  restartTask ({ commit }, taskId) {
    return Vue.api.put('engine/tasks/' + taskId + '/restart')
      .then((res) => commit('task', res.data))
  },
  getTaskLogs (context, data) {
    return Vue.api.post('engine/tasks/' + data.id + '/logs', data).then((res) => {
      const data = {
        logs: res.data.map((log) => moment(log['@timestamp']).format('ddd DD HH:mm:ss') + ' ' + log.msg)
      }

      if (res.data.length > 0) {
        data.after = res.data[res.data.length - 1]['@timestamp']
      }

      return data
    })
  }
}
